/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 *
 * @export
 * @interface PassportData
 */
export interface PassportData {
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportSeries: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportNumber: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportProvider: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportProviderDate: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportProviderCode: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportAddress: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportBirthPlace: string;
}

export function PassportDataFromJSON(json: any): PassportData {
  return PassportDataFromJSONTyped(json, false);
}

export function PassportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PassportData {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    passportSeries: !exists(json, 'passportSeries')
      ? undefined
      : `${json['passportSeries'] ? json['passportSeries'] : ''}`,
    passportNumber: !exists(json, 'passportNumber')
      ? undefined
      : `${json['passportNumber'] ? json['passportNumber'] : ''}`,
    passportProvider: !exists(json, 'passportProvider') ? undefined : json['passportProvider'],
    passportProviderDate: !exists(json, 'passportProviderDate') ? undefined : json['passportProviderDate'],
    passportProviderCode: !exists(json, 'passportProviderCode')
      ? undefined
      : `${json['passportProviderCode'] ? json['passportProviderCode'] : ''}`,
    passportAddress: !exists(json, 'passportAddress') ? undefined : json['passportAddress'],
    passportBirthPlace: !exists(json, 'passportBirthPlace') ? undefined : json['passportBirthPlace'],
  };
}

export function PassportDataToJSON(value?: PassportData | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    passportSeries: value.passportSeries,
    passportNumber: value.passportNumber,
    passportProvider: value.passportProvider,
    passportProviderDate: value.passportProviderDate,
    passportProviderCode: value.passportProviderCode,
    passportAddress: value.passportAddress,
    passportBirthPlace: value.passportBirthPlace,
  };
}
